export const WIZARD_STEPS = {
  UPLOAD: 'upload',
  SUMMARY: 'summary',
  DUPLICATES: 'duplicates',
  MISSING_FIELDS: 'missing-fields',
  WHITESPACE: 'whitespace',
  HARMONISATION: 'harmonisation',
  REVIEW: 'review'
};

export const STEP_CONFIG = {
  [WIZARD_STEPS.UPLOAD]: {
    title: 'Upload Your File',
    subtitle: '',
    order: 1,
    isBlocking: false
  },
  [WIZARD_STEPS.SUMMARY]: {
    title: "We've checked your file",
    subtitle: "Here's what we found",
    order: 2,
    isBlocking: false
  },
  [WIZARD_STEPS.MISSING_FIELDS]: {
    title: 'Missing Information',
    subtitle: 'Every row needs a SectionName, CategoryName & Identifier',
    order: 3,
    isBlocking: true
  },
  [WIZARD_STEPS.DUPLICATES]: {
    title: 'Duplicate Products',
    subtitle: 'Some products appear more than once',
    order: 4,
    isBlocking: true
  },
  [WIZARD_STEPS.WHITESPACE]: {
    title: 'Tidy Up Text',
    subtitle: 'Clean up extra spaces and line breaks',
    order: 5,
    isBlocking: false
  },
  [WIZARD_STEPS.HARMONISATION]: {
    title: 'Standardise Names',
    subtitle: 'Same name, different spelling',
    order: 6,
    isBlocking: false
  },
  [WIZARD_STEPS.REVIEW]: {
    title: 'Review & Import',
    subtitle: 'Check everything looks good',
    order: 7,
    isBlocking: false
  }
};

export function useWizardNavigation() {
  return {
    currentStep: WIZARD_STEPS.UPLOAD,
    stepHistory: [],
    stepsToShow: [],
    
    initializeSteps(validationResults) {
      const steps = [WIZARD_STEPS.UPLOAD];
      
      if (validationResults) {
        if (validationResults.duplicates && validationResults.duplicates.length > 0) {
          steps.push(WIZARD_STEPS.DUPLICATES);
        }
        
        if (validationResults.missingFields && validationResults.missingFields.length > 0) {
          steps.push(WIZARD_STEPS.MISSING_FIELDS);
        }
        
        if (validationResults.whitespaceIssues && validationResults.whitespaceIssues.length > 0) {
          steps.push(WIZARD_STEPS.WHITESPACE);
        }
        
        if (validationResults.harmonisationIssues && validationResults.harmonisationIssues.length > 0) {
          steps.push(WIZARD_STEPS.HARMONISATION);
        }
        
        steps.push(WIZARD_STEPS.REVIEW);
      }
      
      this.stepsToShow = steps;
      return steps;
    },
    
    getNextStep() {
      const currentIndex = this.stepsToShow.indexOf(this.currentStep);
      if (currentIndex < this.stepsToShow.length - 1) {
        return this.stepsToShow[currentIndex + 1];
      }
      return null;
    },
    
    getPreviousStep() {
      const currentIndex = this.stepsToShow.indexOf(this.currentStep);
      if (currentIndex > 0) {
        return this.stepsToShow[currentIndex - 1];
      }
      return null;
    },
    
    goToNextStep() {
      const nextStep = this.getNextStep();
      if (nextStep) {
        this.stepHistory.push(this.currentStep);
        this.currentStep = nextStep;
        return true;
      }
      return false;
    },
    
    goToPreviousStep() {
      const prevStep = this.getPreviousStep();
      if (prevStep) {
        this.currentStep = prevStep;
        this.stepHistory.pop();
        return true;
      }
      return false;
    },
    
    goToStep(step) {
      if (this.stepsToShow.includes(step)) {
        this.stepHistory.push(this.currentStep);
        this.currentStep = step;
        return true;
      }
      return false;
    },
    
    reset() {
      this.currentStep = WIZARD_STEPS.UPLOAD;
      this.stepHistory = [];
      this.stepsToShow = [WIZARD_STEPS.UPLOAD];
    },
    
    isLastStep() {
      return this.currentStep === this.stepsToShow[this.stepsToShow.length - 1];
    },
    
    isFirstStep() {
      return this.currentStep === this.stepsToShow[0];
    },
    
    getProgress() {
      const currentIndex = this.stepsToShow.indexOf(this.currentStep);
      return Math.round(((currentIndex + 1) / this.stepsToShow.length) * 100);
    },
    
    getStepConfig(step) {
      return STEP_CONFIG[step] || null;
    },
    
    getCurrentStepConfig() {
      return STEP_CONFIG[this.currentStep] || null;
    }
  };
}

export default useWizardNavigation;
